var _rect, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgShoppingCartCheckout = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_1689",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_1689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 8.04167L9.125 7.16667L10.6667 5.625H6.875V4.375H10.6667L9.125 2.83333L10 1.95833L13.0417 5L10 8.04167ZM5.95833 17.9583C5.55556 17.9583 5.21194 17.8161 4.9275 17.5317C4.6425 17.2467 4.5 16.9028 4.5 16.5C4.5 16.0972 4.6425 15.7533 4.9275 15.4683C5.21194 15.1839 5.55556 15.0417 5.95833 15.0417C6.36111 15.0417 6.70472 15.1839 6.98917 15.4683C7.27417 15.7533 7.41667 16.0972 7.41667 16.5C7.41667 16.9028 7.27417 17.2467 6.98917 17.5317C6.70472 17.8161 6.36111 17.9583 5.95833 17.9583ZM14.0417 17.9583C13.6389 17.9583 13.2953 17.8161 13.0108 17.5317C12.7258 17.2467 12.5833 16.9028 12.5833 16.5C12.5833 16.0972 12.7258 15.7533 13.0108 15.4683C13.2953 15.1839 13.6389 15.0417 14.0417 15.0417C14.4444 15.0417 14.7881 15.1839 15.0725 15.4683C15.3575 15.7533 15.5 16.0972 15.5 16.5C15.5 16.9028 15.3575 17.2467 15.0725 17.5317C14.7881 17.8161 14.4444 17.9583 14.0417 17.9583ZM1.25 3.125V1.875H3.625L7.10417 9.20833H12.7917C12.8472 9.20833 12.8925 9.19778 12.9275 9.17667C12.9619 9.15611 12.9931 9.125 13.0208 9.08333L16.1042 3.54167H17.5208L14.1042 9.70833C13.9792 9.94444 13.8022 10.1283 13.5733 10.26C13.3439 10.3922 13.0972 10.4583 12.8333 10.4583H6.75L5.79167 12.2292C5.75 12.2986 5.74667 12.3681 5.78167 12.4375C5.81611 12.5069 5.875 12.5417 5.95833 12.5417H15.5V13.7917H5.95833C5.40278 13.7917 4.98278 13.5556 4.69833 13.0833C4.41333 12.6111 4.40972 12.1319 4.6875 11.6458L5.875 9.5L2.83333 3.125H1.25Z",
    fill: "#5A5A5A"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShoppingCartCheckout, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shopping_cart_checkout.abfa5e14.svg";
export { ForwardRef as ReactComponent };